import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_cycle_cutoff_date_RowClass} from '../../../dbschema';

export class ClaimCycleCutoffDateContainerModel extends BaseContainerModel {
  bl_aat_claim_cycle_cutoff_date: bl_aat_claim_cycle_cutoff_date_RowClass = new bl_aat_claim_cycle_cutoff_date_RowClass();
}
